// @flow
import {
  MONTHLY_REPORT_LOADING,
  MONTHLY_REPORT_SUCCESS,
  MONTHLY_REPORT_ERROR,
} from '../actions/monthlyReportActions';

export default (state: Object = {}, action: Object) => {
  switch (action.type) {
    case MONTHLY_REPORT_LOADING:
      return {
        ...state,
        status: 'LOADING',
      };
    case MONTHLY_REPORT_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        data: action.data,
      };
    case MONTHLY_REPORT_ERROR:
      return {
        ...state,
        status: 'ERROR',
        error: action.error,
        data: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/monthlyReportReducer.js